import comp from "./BannerImageBlock.js";
export default comp;
